// extracted by mini-css-extract-plugin
export default {"videoSplit":"videoSplit__lTgfM","section":"section__m4Ls-"};